module.exports = __webpack_public_path__ + "img/ee.c23b1264.svg";